import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { useEffect, useState } from "react";
import { IClientCompanyDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { EmptyFilter } from "./Table";

interface IProps {
    invoiceFilter: InvoiceTrackingFilter,
    setReqFilter: (invoiceFilter: InvoiceTrackingFilter) => void,
    singleData?: any,
    toast: any,
    byPO_ID: boolean
};

export interface InvoiceTrackingFilter {
    year?: Date | null,
    month?: Date | null,
    company?: IClientCompanyDropdown | null,
    prime_Vendor_Billing_Cycle?: number | null,
    invoiceStatus?: number | null,
    paymentStatus?: number | null,
    consultantName?: string | null
}

const schema = yup.object({
    year: yup.date().nullable(),
    month: yup.date().nullable(),
    client: yup.string().nullable(),
    prime_Vendor_Billing_Cycle: yup.string().nullable(),
    invoiceStatus: yup.string().nullable(),
    paymentStatus: yup.string().nullable(),
    consultantName: yup.string().nullable(),
});

export const Filter = (props: IProps) => {
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset } = useForm<InvoiceTrackingFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const onSubmit = (data: InvoiceTrackingFilter) => {
        props.setReqFilter(data);
    };
    const Billing_Cycle = [
        { name: "-- SELECT --", value: 0 },
        { name: "Weekly", value: 1 },
        { name: "Bi-Weekly", value: 2 },
        { name: "Monthly", value: 3 },
    ];
    // const Billing_Cycle = [
    //     { name: "-- SELECT --", value: null },
    //     { name: "Weekly", value: "Weekly" },
    //     { name: "Monthly", value: "Monthly" },
    // ];
    const Payment_Term = [
        { name: "Net 30" },
        { name: "Net 45" },
        { name: "Pay on Pay" },
        { name: "Net 15" },
        { name: "Net 60" },
        { name: "Net 7" }
    ];
    const Invoice_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Not Required", value: "Not Required" },
        { name: "Generated", value: "Generated" },
        { name: "Sent to Client", value: "Sent to Client" },
        { name: "Yet to Generated", value: "Yet to Generated" },
    ];

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodClientCompanies = (event: { query: string }) => {
        loadClientCompanies(event.query);
    };

    useEffect(() => {
        reset(props.invoiceFilter);
    }, [props.invoiceFilter]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDate maxDate={new Date} type={"year"} column={6} label="Year" control={control} name="year" />
                <JVDate maxDate={new Date} type={"month"} column={6} label="Month" control={control} name="month" />
                <JVDropdownInput column={6} completeMethod={completeMethodClientCompanies} label="Company Name" control={control} name="company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client/Company" />
                <JVDropdown column={6} label="Invoice Cycle" control={control} name="prime_Vendor_Billing_Cycle" options={Billing_Cycle} optionLabel="name" optionValue="name" placeholder="Select Invoice Cycle" />
                <JVDropdown column={6} label="Invoice Status" control={control} name="invoiceStatus" options={Invoice_Status} optionLabel="name" optionValue="name" placeholder="Select Invoice Status" />
                <JVDropdown column={6} label="Payment Status" control={control} name="paymentStatus" options={Payment_Term} optionLabel="name" optionValue="name" placeholder="Select Payment Status" />
                <JVInput column={6} required label="Consultant Name" control={control} name="consultantName" error={errors.consultantName?.message} />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter) }} type="button"></Button>
                </div>
            </form>
        </>
    );
}